import Masonry from "react-masonry-css"
import { Link } from "react-router-dom"
import { LazyLoadImage } from 'react-lazy-load-image-component';

const MasonryColumns = {
    default: 6,
    2000: 5,
    1700: 4,
    1500: 3,
    1200: 2,
    900: 1,
  }

function MasonryDrawings({ drawings, selectedCatId, categories }) {
    const categoryNameIdMap = categories.reduce((acc, crt) => {
        acc[crt.id] = crt.name
        return acc
    }, {})

    return (
        <Masonry breakpointCols={MasonryColumns} className="drawings-list" columnClassName="drawings-list-column">
            {drawings
                .filter(({ categories }) => (selectedCatId === "all" || categories.includes(selectedCatId)))
                .map(({ drawingId, svgUrl, imageUrl, name, categories }) =>
                    <div className="drawing-card" key={drawingId}>
                        <Link className="img-link" to={"/coloring/" + drawingId}>
                            <LazyLoadImage alt={name} src={imageUrl || svgUrl} />
                        </Link>
                        <div className="drawing-card-categories">
                            {categories.map(id => (
                                <h6 className="cat" key={id}>
                                    <Link to={"/?category=" + id}>#{categoryNameIdMap[id]}</Link>
                                </h6>
                            ))}
                        </div>
                    </div>
                )}
        </Masonry>
    )
}

export default MasonryDrawings
